import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled, {ThemeProvider} from "styled-components"

import mainTheme from "@irati/ui/src/global/theme"
import {Label} from "@irati/ui/src/Typography"

import {Container, InverseGeoPin, Number, Text} from "./styled/Address"

class Address extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    city: PropTypes.string,
    postCode: PropTypes.string,
    number: PropTypes.number,
    className: PropTypes.string
  }
  static defaultProps = {
    city: null,
    postCode: null,
    number: null,
    className: null
  }

  render() {
    const {number, title, city, postCode, className} = this.props

    return (
      <ThemeProvider theme={mainTheme}>
        <Container className={className}>
          {number ? <Number>{number}</Number> : <InverseGeoPin icon="geoPin" size={12} />}
          <Text>
            <Label large>{title}</Label>
            {city && <Label display="block" color="contrast">{city}</Label>}
            {postCode && <Label color="contrast">{postCode}</Label>}
          </Text>
        </Container>
      </ThemeProvider>
    )
  }
}

export default styled(Address)``
